module.exports = __webpack_public_path__ + "static/SONO-18001-474b6e7af6f280f5df60efaf0fa79831.jpg";